import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class TraspasoClienteService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerMarcacionMasiva(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad:traspaso_clienteInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          traspaso_cliente {
            obtenerMarcacionMasiva(entidad:$entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros{
                  codigo_marcacion
                  detalle
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.traspaso_cliente.obtenerMarcacionMasiva;
            callback({ mensajes, respuesta });
        });
    }
    obtenerMarcacionSegunClientes(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: cliente_proveedorInputType, $listaCliente: [cliente_proveedorInputType], $tipo_marcacion: Int, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          cliente_proveedor {
            seleccionarClienteSegunMarcacion(entidad: $entidad, listaCliente: $listaCliente, tipo_marcacion: $tipo_marcacion, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  empresa_rut
                  codigo_vendedor
                  rut
                  razon_social
                  activo
                  codigo_direccion
                  direccion_completa
                  nombrecomuna
                  nombreprovincia
                  ruta_codigo
                  ruta_nombre
                  territorio_codigo
                  nombreTerritorio
                  lunes
                  martes
                  miercoles
                  jueves
                  viernes
                  sabado
                  domingo
                  tipo_cliente_codigo
                  tipo_cliente_nombre
                  seleccion
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.cliente_proveedor.seleccionarClienteSegunMarcacion;
            callback({ mensajes, respuesta });
        });
    }
}
TraspasoClienteService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TraspasoClienteService_Factory() { return new TraspasoClienteService(i0.ɵɵinject(i1.GraphQLClient)); }, token: TraspasoClienteService, providedIn: "root" });
